import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
    container: { flexDirection: 'column', display: 'flex' },
    textLabel: {
      font: theme.custom.font.label,
      color: theme.custom.colors.primary,
    },
    errors: {
      color: '#C83C5D',
      marginTop: 8,
      fontSize: 16, 
      fontFamily: 'Montserrat',
    },
    containerErr: {
      '& label': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& span': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& textarea': {
        // border: `1px solid ${theme.custom.colors.error1} !important`,
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderLeft: 'none',
        borderRight: 'none',
        boxShadow: `0 0 0 1px ${theme.custom.colors.error1}`,
        color: `${theme.custom.colors.error1} !important`,
      },
    },
    disable: {
      '& span': {
        color: `${theme.custom.colors.borderGrey} !important`,
      },
      '& textarea': {
        // border: `1px solid ${theme.custom.colors.borderGrey} !important`,
        borderTop: '6px solid transparent',
        borderBottom: '6px solid transparent',
        borderLeft: 'none',
        borderRight: 'none',
        boxShadow: `0 0 0 1px ${theme.custom.colors.borderGrey}`,
        color: `${theme.custom.colors.borderGrey} !important`,
        cursor: 'not-allowed',
      },
    },
    textOptional: {
      font: theme.custom.font.label,
      color: theme.custom.colors.placeholder,
    },
    textArea: {
      resize: 'none',
      // border: '1px solid #000000',
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderLeft: 'none',
      borderRight: 'none',
      boxShadow: '0 0 0 1px #000',
      padding: '12px 16px',
      height: '214px',
      borderRadius: '6px',
      font: theme.custom.font.placeholder,
      '&::placeholder': {
        font: theme.custom.font.placeholder,
        color: theme.custom.colors.placeholder,
      },
      '&:focus': {
        outline: 'none',
      },
    },
  };
});

export default useStyles;
